import {
  Box,
  Button,
  IconButton,
  Image,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from '@astro-ui/components'
import { dateFormat } from 'utils/helpers/date'
import { Edit, Trash } from '@astronautsid/wpe-icons'
import { OutboundSOAddEditSliceType } from 'features/SupplyOrder/redux/outboundSOAddEdit'
import { PutSupplyOrderDetailRequestType } from 'features/SupplyOrder/services/outboundSO'
import useRow from './useRow'

type RowPropsType = {
  product: OutboundSOAddEditSliceType['products']['item'][0]
  supplyOrderRequest: PutSupplyOrderDetailRequestType['supplyOrderRequest']
}

const Row = ({ product, supplyOrderRequest }: RowPropsType) => {
  const { isEdit, qty, handleIsEdit, handleChangeQty, handleDelete, handleSave } = useRow({
    product,
    supplyOrderRequest,
  })

  return (
    <TableRow key={product.supplyOrderProductDetailId}>
      <TableCell textAlign="center">1</TableCell>
      <TableCell>
        <Box display="flex" gap="8px" alignItems="center">
          <Image src={product.productImage} width="40px" height="40px" mr={12} />
          <Typography>{product.productName}</Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography>{product.productSku}</Typography>
      </TableCell>
      <TableCell>
        <Typography whiteSpace="nowrap">
          {product.productExpDate
            ? dateFormat({
                date: new Date(product.productExpDate),
                format: 'DD MMM YYYY',
              })
            : '-'}
        </Typography>
      </TableCell>
      <TableCell textAlign="center">
        {isEdit ? (
          <TextField
            sx={{ width: '80px' }}
            value={qty}
            onChange={(e) => handleChangeQty(e.target.value)}
          />
        ) : (
          <Typography>{product.productRequestQuantity}</Typography>
        )}
      </TableCell>
      <TableCell textAlign="center">
        <Typography>{product.productUom}</Typography>
      </TableCell>
      <TableCell textAlign="center">
        {isEdit ? (
          <Box display="flex" gap="4px" justifyContent="center">
            <Button size="small" onClick={handleSave}>
              Save
            </Button>
            <Button size="small" variant="outlined" onClick={() => handleIsEdit(false)}>
              Cancel
            </Button>
          </Box>
        ) : (
          <Box display="flex" gap="4px" justifyContent="center">
            <IconButton onClick={() => handleIsEdit(true)}>
              <Edit size={16} />
            </IconButton>

            <IconButton onClick={handleDelete}>
              <Trash size={16} />
            </IconButton>
          </Box>
        )}
      </TableCell>
    </TableRow>
  )
}

export default Row
